// extracted by mini-css-extract-plugin
export default {"payments":"cg-z","header":"dg-z","adjustMarginAndPaddingNewDesign":"eg-z"};